export const REPORT_ID = 'slide-21';
export const SLIDE_NUMBER = 21;